import React, { Component, ReactNode } from 'react';
import { NavigateFunction } from 'react-router-dom';
import initialMetricsPublisher from 'src/metrics';
import * as KatalMetrics from '@amzn/katal-metrics';

interface Props {
    children: ReactNode;
    navigate: NavigateFunction;
}

interface State {
    hasError: boolean;
}

class ErrorBoundary extends Component<Props, State> {
    constructor(props: Props) {
        super(props);
        this.state = { hasError: false };
    }

    static getDerivedStateFromError(): State {
        return { hasError: true };
    }

    componentDidCatch(error: Error, errorInfo: React.ErrorInfo) {
        const errorMetricsPublisher =
            initialMetricsPublisher.newChildActionPublisherForMethod(
                'JavaScriptError'
            );

        const truncateString = (str: string, maxLength: number = 200) => {
            return str.length > maxLength
                ? str.substring(0, maxLength) + '...'
                : str;
        };

        const errorData = {
            message: truncateString(error.message),
            stack: truncateString(error.stack || 'No stack trace available'),
            componentStack: truncateString(errorInfo.componentStack || ''),
            url: truncateString(window.location.href),
            timestamp: new Date().toISOString(),
        };

        errorMetricsPublisher.publish(
            new KatalMetrics.Metric.String(
                'gru.error.react',
                JSON.stringify(errorData)
            )
        );

        setTimeout(() => {
            this.props.navigate('/error');
        }, 100);
    }

    render() {
        if (this.state.hasError) {
            return null;
        }

        return this.props.children;
    }
}

export default ErrorBoundary;
